import { API_URLS_LIST } from '@config/api-config';
import axiosInstance from '@services/api/axios-wrapper-service';

export const getContent = async (pageName: string, state: string = '') => {
  try {
    const request = {
      pageName: pageName.replace(/\//g, ''),
      state: state
    };
    const response: any = await axiosInstance.post(
      API_URLS_LIST.getContent,
      request
    );
    if (response.status === 'SUCCESS') {
      return response.data;
    } else {
      throw new Error('Error fetching content from Strapi');
    }
  } catch (error) {
    console.error('Error fetching content from Strapi:', error);
    throw error;
  }
};
